import PropTypes from "prop-types";
import { useContext, useState, useSyncExternalStore } from "react";

import { CommandPalette } from "./index";
import {
  CommandPaletteRegistrationContext,
  createCommandPaletteRegistrationStore,
} from "./commandPaletteRegistration";

const CommandPaletteHost = () => {
  const store = useContext(CommandPaletteRegistrationContext);
  const { options, title } = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot,
  );
  return <CommandPalette options={options} title={title} />;
};

const CommandPaletteProvider = ({ children }) => {
  const [store] = useState(createCommandPaletteRegistrationStore);

  return (
    <CommandPaletteRegistrationContext.Provider value={store}>
      {children}
      <CommandPaletteHost />
    </CommandPaletteRegistrationContext.Provider>
  );
};

CommandPaletteProvider.propTypes = {
  children: PropTypes.node,
};

export { CommandPaletteProvider };
